import { Text } from "@mantine/core";
import type * as React from "react";

/** A secondary line (`text/secondary`, 13px): "Last saved", usage counts, notes under a
 * table. */
export function MetaText({ children }: { children: React.ReactNode }) {
  return (
    <Text c="dimmed" lh={1.25}>
      {children}
    </Text>
  );
}
